import { useState } from "react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { RoutineItem } from "../RoutineItem";

interface PersonalRoutinesSectionProps {
  routines: any[];
  openSection: string;
  setOpenSection: (section: string) => void;
  currentIndex: number;
  onTabChange: (value: string) => void;
  refetchRoutines: () => void;
  showInPlan?: boolean;
}

export const PersonalRoutinesSection = ({
  routines,
  openSection,
  setOpenSection,
  currentIndex,
  onTabChange,
  refetchRoutines,
  showInPlan = false
}: PersonalRoutinesSectionProps) => {
  if (!routines || routines.length === 0 || !showInPlan) return null;

  return (
    <div className="mt-4">
      <Tabs value={currentIndex.toString()} onValueChange={onTabChange}>
        <ScrollArea className="w-full whitespace-nowrap rounded-xl">
          <TabsList className="inline-flex w-max min-w-full">
            {routines.map((routine, index) => (
              <TabsTrigger
                key={index}
                value={index.toString()}
                className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground px-4"
              >
                {routine.name}
              </TabsTrigger>
            ))}
          </TabsList>
          <ScrollBar orientation="horizontal" className="bg-white/10" />
        </ScrollArea>

        <div className="mt-4">
          <RoutineItem
            key={routines[currentIndex].id}
            routine={routines[currentIndex]}
            refetchRoutines={refetchRoutines}
          />
        </div>
      </Tabs>
    </div>
  );
};